export function isObject(object: unknown): object is object {
  return !!object && typeof object === 'object';
}
